function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import classNames from "classnames";
import colors from "/styles/colors";
import { getOnelinkWithTrackingParams } from "services/onelink-service";
import { MOBILE_DOWNLOAD_LINK_CLICK } from "/constants/bigbrain-event-types";
import SignupFormComponent from "components/core/signups/base-signup-form/signup-form-component";
import CollaborationWithComponent from "../../collaboration-with/collaboration-with-component";
import Button from "/components/core/button/button-component";
import { sendCookies } from "/services/platform-api-service";
import { getAllCookies, getCookie } from "/services/cookies-service";
import { BIG_BRAIN_VISITOR_ID } from "/constants/cookies";
import componentStyles from "./text-part-component.scss";
class TextPartComponent extends PureComponent {
    shouldRenderSubtitle() {
        const { mobileTitleLines } = this.props;
        return mobileTitleLines.length < 3;
    }
    onDownloadLinkClicked(e) {
        // Send cookies to the server.
        let visitorId = getCookie(BIG_BRAIN_VISITOR_ID);
        if (visitorId) {
            const cookies = getAllCookies();
            sendCookies(visitorId, cookies);
        }
        BigBrain("track", MOBILE_DOWNLOAD_LINK_CLICK);
        window.open(getOnelinkWithTrackingParams());
    }
    removeBoldTagForText(text) {
        return text ? text.replace(/<b>/g, "").replace(/<\/b>/g, "") : "";
    }
    render() {
        const { mobileTitleLines, mobileSubtitleLines, signupForm, collaborationWith, customStyle, color, isMobileCleanLook, isMobileOnly } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + (classNames("text-part-component", {
                [customStyle]: !!customStyle,
                "mobile-only": isMobileOnly
            }) || ""),
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    className: `jsx-${componentStyles.__hash}` + " " + "title-lines-wrapper",
                    children: mobileTitleLines.map((line, index)=>/*#__PURE__*/ _jsx("span", {
                            style: {
                                color: colors[color]
                            },
                            dangerouslySetInnerHTML: {
                                __html: isMobileCleanLook ? this.removeBoldTagForText(line) : line
                            },
                            className: `jsx-${componentStyles.__hash}` + " " + (classNames("title-line", {
                                first: index == 0
                            }) || "")
                        }, index))
                }),
                this.shouldRenderSubtitle() && /*#__PURE__*/ _jsx("h2", {
                    className: `jsx-${componentStyles.__hash}` + " " + "subtitle-lines-wrapper",
                    children: mobileSubtitleLines.map((line, index)=>/*#__PURE__*/ _jsx("span", {
                            style: {
                                color: colors[color]
                            },
                            dangerouslySetInnerHTML: {
                                __html: line
                            },
                            className: `jsx-${componentStyles.__hash}` + " " + "subtitle-line"
                        }, index))
                }),
                signupForm.showDownloadButtonOnMobile ? /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "mobile-download-button-wrapper",
                    children: /*#__PURE__*/ _jsx(Button, {
                        className: "mobile-download-button",
                        color: signupForm.buttonColor,
                        onClickCallback: this.onDownloadLinkClicked,
                        children: signupForm.downloadButtonTitle
                    })
                }) : /*#__PURE__*/ _jsx("div", {
                    className: `jsx-${componentStyles.__hash}` + " " + "signup-form-wrapper",
                    children: /*#__PURE__*/ _jsx(SignupFormComponent, {
                        placeholder: signupForm.inputPlaceholder,
                        ctaText: signupForm.buttonText,
                        useCtaText: !!signupForm.buttonText,
                        buttonColor: signupForm.buttonColor
                    })
                }),
                collaborationWith.show && /*#__PURE__*/ _jsx(CollaborationWithComponent, _object_spread({}, collaborationWith)),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
}
export { TextPartComponent as default };
TextPartComponent.defaultProps = {
    mobileTitleLines: [],
    mobileSubtitleLines: []
};
